export default {
  /**
   * @description api请求基础路径
   */
  apiUrl: {
    dev: 'https://acbi-dev.azsoft.xin/api',// 本地
    dev2: '/api2',// 本地
    dev3: '/api3',// 本地
    dev3: '/api4',// 本地
    // dev: 'http://acbi.azsoft.xin/api', // 正式环境
    // dev2: 'https://openapp.azsoft.xin', // 正式环境
    pro: 'https://acbi-dev.azsoft.xin/api', // 线上环境
    pro2: 'https://openapp.azsoft.xin', // 线上环境
    pro3: 'https://www.tianqiapi.com', // 线上环境
    pro4: 'https://rbac-dev.azsoft.xin',// 本地

    // pro: 'http://acbi.azsoft.xin/api', // 正式环境
    // pro2: 'https://openapp.azsoft.xin', // 正式环境
    test: 'http://acbi.azsoft.xin/api'
  },
  // urlWeather: 'https://www.tianqiapi.com/api?version=v6&appid=75132389&appsecret=zrlE1Zfr',
  // urlWeather: 'https://www.tianqiapi.com/api/?version=v6&appid=48871973&appsecret=KXiso1p5',
  // urlWeather: 'https://www.tianqiapi.com/api/?version=v6&appid=[48871973]&appsecret=[KXiso1p5]',
  urlWeather: 'https://www.tianqiapi.com/api/?version=v6&appid=75721589&appsecret=ra1IEX9K',
  // 请求白名单 无需token
  apiWhite: [
    'Login',
    '/api/app/sms/verification-code',
    '/api/app/we-chat/request-token-by-open-id',
    '/api/app/sms/request-token-by-phone-number',
     '/api/Account/TenantSwitchById',
    // '/api/abp/application-configuration',
  '/api/?version=v6&appid=75721589&appsecret=ra1IEX9K'],
  tokenName: 'TOKEN_KEY',
  setTenant: '__TENANT_ID__',
  setUser: '__USER__',
  setTenantname: '__TENANT_NAME__',
  setDomains: '__DOMAINS__',
  ///////////新认证start////////
  wxLoginUrl: 'https://openapp.azsoft.xin/api/account/LoginByWeChat?redirectUrl=https://acbi-dev.azsoft.xin/index&__tenant=',
  // wxLoginUrl: 'https://openapp.azsoft.xin/api/account/LoginByWeChat?redirectUrl=http://localhost:8080/index&__tenant=',
  setBind: '__IS_BIND__', // 是否绑定
  setOpenId: '__OPEN_ID__', 
  setTenantIds: '__TENANT_IDS__', // 商户id
  setTenantNames: '__TENANT_NAMES__', // 商户名称
  setConfigurations: '__SET_CONFIGURATIONS__', // 权限配置
  ///////////新认证end////////
  menu_num: 'MENU_NUM', // 全局菜单
  menu: '_MENU_',
  mp: 'MP_SET',
  sub_menu: '_SUB_MENU_'
}



// WEBPACK FOOTER //
// ./src/config/config.js